module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#proofread",
      toString: function () {
        return this.url;
      }
    }